/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_LocationInputs */

const en_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const es_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación`)
};

const de_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort`)
};

const zh_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地点`)
};

const ar_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموقع`)
};

const fr_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplacement`)
};

const vi_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa điểm`)
};

const sw_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahali`)
};

const th_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่ตั้ง`)
};

const bs_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokacija`)
};

const ja_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセス`)
};

const ko_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`위치`)
};

const pt_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localização`)
};

const it_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione`)
};

const sv_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plats`)
};

const nl_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locatie`)
};

const da_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sted`)
};

const nb_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beliggenhet`)
};

const fi_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sijainti`)
};

const pl_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalizacja`)
};

const ru_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расположение`)
};

const tr_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konum`)
};

const hi_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थान`)
};

const id_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokasi`)
};

const ms_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokasi`)
};

const cs_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umístění`)
};

const el_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τοποθεσία`)
};

const he_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מיקום`)
};

const af_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligging`)
};

const hu_contact_location = /** @type {(inputs: Contact_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hely`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Contact_LocationInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_location = /** @type {((inputs?: Contact_LocationInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_LocationInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_location(inputs)
	if (locale === "de") return de_contact_location(inputs)
	if (locale === "zh") return zh_contact_location(inputs)
	if (locale === "ar") return ar_contact_location(inputs)
	if (locale === "fr") return fr_contact_location(inputs)
	if (locale === "vi") return vi_contact_location(inputs)
	if (locale === "sw") return sw_contact_location(inputs)
	if (locale === "th") return th_contact_location(inputs)
	if (locale === "bs") return bs_contact_location(inputs)
	if (locale === "ja") return ja_contact_location(inputs)
	if (locale === "ko") return ko_contact_location(inputs)
	if (locale === "pt") return pt_contact_location(inputs)
	if (locale === "it") return it_contact_location(inputs)
	if (locale === "sv") return sv_contact_location(inputs)
	if (locale === "nl") return nl_contact_location(inputs)
	if (locale === "da") return da_contact_location(inputs)
	if (locale === "nb") return nb_contact_location(inputs)
	if (locale === "fi") return fi_contact_location(inputs)
	if (locale === "pl") return pl_contact_location(inputs)
	if (locale === "ru") return ru_contact_location(inputs)
	if (locale === "tr") return tr_contact_location(inputs)
	if (locale === "hi") return hi_contact_location(inputs)
	if (locale === "id") return id_contact_location(inputs)
	if (locale === "ms") return ms_contact_location(inputs)
	if (locale === "cs") return cs_contact_location(inputs)
	if (locale === "el") return el_contact_location(inputs)
	if (locale === "he") return he_contact_location(inputs)
	if (locale === "af") return af_contact_location(inputs)
	if (locale === "hu") return hu_contact_location(inputs)
	return en_contact_location(inputs)
});